var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrientationHelper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258.03055,
    height: 258.02768,
    viewBox: "0 0 258.03055 258.02768",
    fill: "none",
    id: "svg2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "orientation_helper"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.17516,
    cy: 109.19122,
    r: 127,
    transform: "rotate(8.24109)",
    stroke: "url(#paint0_linear_460_2375)",
    strokeWidth: 4,
    strokeDasharray: "4, 4",
    id: "circle1",
    style: {
      stroke: "url(#paint0_linear_460_2375)"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_2375",
    x1: 0.99995399,
    y1: 130.002,
    x2: 259,
    y2: 130.002,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.175151,-20.810775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E61",
    id: "stop1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC01",
    id: "stop2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_2380",
    x1: 35.736599,
    y1: 6.0286598,
    x2: 25.7642,
    y2: 42.597401,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(150,23.460265,22.290605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E61",
    id: "stop1-3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC01",
    id: "stop2-6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_2372",
    x1: 3.4786899,
    y1: 247.13699,
    x2: 76.478699,
    y2: 5.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E61",
    id: "stop1-5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC01",
    id: "stop2-62"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g2",
    transform: "rotate(180,75.200098,127.58554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.089439,45.765805 38.737523,8.374668 C 39.612347,5.7883193 37.696358,3.1050439 34.966148,3.0929521 L 8.391266,2.9752051 C 5.5964315,2.9628298 3.6508386,5.7474088 4.6236099,8.3674845 L 18.550479,45.8764 c 1.311311,3.531542 6.33183,3.457929 7.53896,-0.110595 z",
    fill: "url(#paint0_linear_460_2380)",
    stroke: "url(#paint1_linear_460_2380)",
    id: "path1",
    style: {
      fill: "url(#paint0_linear_460_2380)",
      stroke: "url(#paint0_linear_460_2380)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g3",
    transform: "rotate(73,81.204397,188.74286)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.56392,
    y1: 246.55901,
    x2: 74.563904,
    y2: 4.559,
    stroke: "url(#paint0_linear_460_2372)",
    strokeWidth: 3,
    id: "line1",
    style: {
      stroke: "url(#paint0_linear_460_2372)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientationHelper);
export default __webpack_public_path__ + "static/media/orientation_helper.ff4c99524dc8bfda3e405cd743b674c4.svg";
export { ForwardRef as ReactComponent };